import type { ReactNode } from 'react';
import { Link } from 'react-router-dom';
import type { Person } from './api';

// Neuer Tab: Filter, Seite und offenes Transkript leben nur im State dieser Seite.
export function UserLink({ user, children, className = 'text-accent-light hover:underline' }: { user: Person; children: ReactNode; className?: string }): JSX.Element {
  return <Link to={`/users/${encodeURIComponent(user.id)}`} target="_blank" rel="noopener noreferrer" className={className}>{children}<span className="sr-only"> (öffnet in neuem Tab)</span></Link>;
}
